import { useAuthenticator } from '@aws-amplify/ui-react';
import store from '../state-manager/store';
import { resetAction } from '../state-manager/actions/resetAction';
import { useCallback, useEffect, useRef } from 'react';
import { LogoutReason, recordLogout } from '../services/authEventService';

// Pass a reason when the user (or the idle timer) ends the session in THIS tab, so
// the logout is audited first. Call with no reason to sign out without auditing:
// a tab following another tab's sign-out must not record a second logout.
export default function useSignOut() {
  const { signOut, authStatus } = useAuthenticator((context) => [context.route]);
  const prevState = useRef<string>(authStatus);

  useEffect(() => {
    if (prevState.current === 'authenticated' && authStatus === 'unauthenticated') {
      window.postMessage('message');
      store.dispatch(resetAction());
      location.href = '/';
    }
    prevState.current = authStatus;
  }, [authStatus]);

  return useCallback(
    async (reason?: LogoutReason) => {
      if (reason) {
        await recordLogout(reason);
      }
      signOut();
    },
    [signOut],
  );
}
